import React from "react";
import { Route, Routes } from "react-router-dom";
import { ReportSettingsList } from "./containers";

export const ReportSettings = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<ReportSettingsList />} />
      </Routes>
    </>
  );
};
